import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  Alert,
  Stack,
} from "@mui/material";
import { Login as LoginIcon, Google as GoogleIcon } from "@mui/icons-material";
import { authService } from "@catalog/supabase";

const LoginPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await authService.signInWithGoogle();

      if (result.error) {
        setError(result.error);
        setIsLoading(false);
      }
      // If successful, user will be redirected to the callback URL
    } catch (err: any) {
      setError(err.message || "An error occurred during Google sign-in.");
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Card sx={{ width: "100%", maxWidth: 400 }}>
          <CardContent sx={{ p: 4 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 3,
              }}
            >
              <LoginIcon sx={{ mr: 1 }} />
              <Typography variant="h5" component="h1">
                Sign In
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}

            {/* Google Sign-In Button */}
            <Button
              fullWidth
              variant="outlined"
              onClick={handleGoogleLogin}
              disabled={isLoading}
              startIcon={<GoogleIcon />}
              sx={{
                mb: 3,
                py: 1.5,
                borderColor: "#dadce0",
                color: "#3c4043",
                "&:hover": {
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.08)"
                      : "#f8f9fa",
                  borderColor: "#dadce0",
                },
              }}
            >
              {isLoading ? "Signing In..." : "Continue with Google"}
            </Button>

            <Stack spacing={1} sx={{ mt: 2, textAlign: "center" }}>
              <Typography variant="body2" color="text.secondary">
                Access is restricted to approved users only.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Contact the administrator if you need access.
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default LoginPage;
